import { lazy, Suspense } from 'react';

const LazyApplicationBody = lazy(() => import('./application-body.jsx'));

const ApplicationBody = (props) => (
  <Suspense fallback={null}>
    <LazyApplicationBody {...props} />
  </Suspense>
);

export default ApplicationBody;
